import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
    methods: {
        async generatePdf() {
            try {
                this.isDisableDownloadReportBtn = true;

                let pdf = new jsPDF(this.pdfOption);

                const pdf_width = pdf.internal.pageSize.width;
                const pdf_height = pdf.internal.pageSize.height;

                const margin_l = this.pdfConfig.margin.l;
                const margin_t = this.pdfConfig.margin.t;
                const margin_b = this.pdfConfig.margin.b;

                let cellHeight = 35;

                const addNewPageIfNeeded = (incrementValue) => {
                    if ((pdf_position_y + incrementValue) >= pdf_height - margin_t) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset the position to the top of the new page
                    } else {
                        pdf_position_y += incrementValue; // Add the input value
                    }
                };

                let pdf_position_y = 0;
                pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
                pdf.addFileToVFS("Sarabun-Regular.ttf", font);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

                pdf.setFont("Sarabun", "bold");
                pdf.setFontSize(this.pdfConfig.typo.header);
                pdf_position_y += margin_t;
                this.thaitext(
                    pdf,
                    "รายงานการทดลองเรียน",
                    pdf_width / 2,
                    pdf_position_y,
                    0,
                    "center"
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                this.thaitext(
                    pdf,
                    "วันที่พิมพ์ : " + ' ' + this.formatDateToThai(this.moment().format("YYYY-MM-DD"), false),
                    pdf_width - 40,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                let hasPurchaseDate = this.trialRegistrationDate.start ? true : false;
                let startDate = this.moment(this.trialRegistrationDate.start).format("YYYY-MM-DD");
                let endDate = this.moment(this.trialRegistrationDate.end).format("YYYY-MM-DD");
                this.thaitext(
                    pdf,
                    "ข้อมูลวันที่ : " + (hasPurchaseDate ? this.formatDateToThai(startDate, false) + ' - ' + this.formatDateToThai(endDate, false) : '-'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ชื่อคอร์ส : " + (this.selectedCourse.courseName || 'ทั้งหมด'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "วิชา : " + (this.selectedSubjectText || 'ทั้งหมด'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                if (this.selectedCourse.courseName) {
                    const tableHeader = ["รหัสผู้เรียน", "ชื่อผู้เรียน", "ระยะเวลา\nเรียน\n(ชั่วโมง:นาที)"];
                    const colWidths = [50, 260, 55];
                    let headerX = 40;
                    pdf.setLineWidth(0.1);
                    pdf.setFont("Sarabun", "bold");

                    const fontSize = pdf.getFontSize();
                    const fontHeight = fontSize * 0.3528;
                    const lineSpacing = 5; // Extra padding between multiline texts

                    const renderTableHeader = () => {
                        pdf.setFont("Sarabun", "bold");

                        for (let i = 0; i < tableHeader.length; i++) {
                            const width = colWidths[i];

                            // 1. Draw Header Cell Border
                            pdf.rect(headerX, pdf_position_y, width, cellHeight);

                            // 2. Split text by newline for multiline support
                            const lines = tableHeader[i].split('\n');
                            const totalLines = lines.length;

                            // Calculate the starting Y position so the entire block of text is vertically centered
                            const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                            let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                            // 3. Loop through and center each individual line
                            for (let j = 0; j < totalLines; j++) {
                                const lineText = lines[j];

                                // Calculate horizontal center for the current line
                                const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                                const textX = headerX + (width - textWidth) / 2;

                                // Render the text using your custom Thai text function
                                this.thaitext(pdf, lineText, textX, startY);

                                // Move Y down for the next line
                                startY += fontHeight + lineSpacing;
                            }

                            headerX += width;
                        }
                        pdf_position_y += cellHeight;

                        pdf.setFont("Sarabun", "normal");
                        cellHeight = 20
                    }

                    // Create table header
                    renderTableHeader();

                    pdf.setFont("Sarabun", "normal");
                    cellHeight = 20

                    const maxPrintableY = pdf_height - margin_b;

                    this.trialCourseHistoryList.forEach((row) => {
                        let columnX = margin_l;
                        const txtId = row.studentId ? row.studentId.toString() : '-';
                        const learningTime = this.formattedTime(row.learningTime);

                        // 1. Split long text into arrays of wrapped lines
                        const padding = 10;
                        const nameLines = pdf.splitTextToSize(row.fullName, colWidths[1] - padding);

                        // 2. Calculate heights for individual text blocks
                        const fontHeight = pdf.getFontSize() * 0.3528;
                        const lineSpacing = 5;
                        const calculatedNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing) + 10;

                        // 3. Find the maximum height for the entire row
                        const finalRowHeight = Math.max(cellHeight, calculatedNameHeight);

                        // ==========================================
                        // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                        // ==========================================
                        if (pdf_position_y + finalRowHeight > maxPrintableY) {
                            pdf.addPage();
                            pdf_position_y = margin_t; // Reset to the top of the new page

                            // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                            headerX = margin_l;
                            renderTableHeader();
                        }
                        // ==========================================

                        // --- DRAW COLUMN 1: Student ID ---
                        pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                        this.thaitext(pdf, txtId, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[0];

                        // --- DRAW COLUMN 2: Student Name ---
                        pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                        const totalNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing);
                        let nameY = pdf_position_y + (finalRowHeight - totalNameHeight) / 2 + fontHeight;
                        nameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, nameY);
                            nameY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[1];

                        // --- DRAW COLUMN 3: Learning Time ---
                        pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                        this.thaitext(pdf, learningTime, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[2];

                        // 4. Move Y down cleanly by the shared unified row height
                        pdf_position_y += finalRowHeight;
                    });
                } else {
                    const tableHeader = ["รหัสผู้เรียน", "ชื่อผู้เรียน", "รหัส\nคอร์ส", "ชื่อคอร์ส", "วันที่\nลงทะเบียน", "ระยะเวลา\nเรียน\n(ชั่วโมง:นาที)"];
                    const colWidths = [50, 75, 40, 75, 70, 55];
                    let headerX = 40;
                    pdf.setLineWidth(0.1);
                    pdf.setFont("Sarabun", "bold");

                    const fontSize = pdf.getFontSize();
                    const fontHeight = fontSize * 0.3528;
                    const lineSpacing = 5; // Extra padding between multiline texts

                    const renderTableHeader = () => {
                        pdf.setFont("Sarabun", "bold");

                        for (let i = 0; i < tableHeader.length; i++) {
                            const width = colWidths[i];

                            // 1. Draw Header Cell Border
                            pdf.rect(headerX, pdf_position_y, width, cellHeight);

                            // 2. Split text by newline for multiline support
                            const lines = tableHeader[i].split('\n');
                            const totalLines = lines.length;

                            // Calculate the starting Y position so the entire block of text is vertically centered
                            const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                            let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                            // 3. Loop through and center each individual line
                            for (let j = 0; j < totalLines; j++) {
                                const lineText = lines[j];

                                // Calculate horizontal center for the current line
                                const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                                const textX = headerX + (width - textWidth) / 2;

                                // Render the text using your custom Thai text function
                                this.thaitext(pdf, lineText, textX, startY);

                                // Move Y down for the next line
                                startY += fontHeight + lineSpacing;
                            }

                            headerX += width;
                        }
                        pdf_position_y += cellHeight;

                        pdf.setFont("Sarabun", "normal");
                        cellHeight = 20
                    }

                    // Create table header
                    renderTableHeader();

                    pdf.setFont("Sarabun", "normal");
                    cellHeight = 30
                    let finalRowHeight = Math.max(cellHeight);

                    const maxPrintableY = pdf_height - margin_b;

                    this.trialCourseHistoryList.forEach((row) => {
                        let columnX = margin_l;
                        const txtId = row.studentId ? row.studentId.toString() : '-';
                        const enrolledAt = this.thaiDateFilter(row.startDate);
                        const learningTime = this.formattedTime(row.learningTime);
                        const courseCode = row.courseCode ? row.courseCode : "-"

                        // 1. Split long text into arrays of wrapped lines
                        const padding = 10;
                        const nameLines = pdf.splitTextToSize(row.fullName, colWidths[1] - padding);
                        const courseNameLines = pdf.splitTextToSize(row.courseName, colWidths[3] - padding);
                        const courseCodeLines = pdf.splitTextToSize(courseCode, colWidths[2] - padding);

                        // 2. Calculate heights for individual text blocks
                        const fontHeight = pdf.getFontSize() * 0.3528;
                        const lineSpacing = 5;
                        const calculatedNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing) + 10;
                        const calculatedCourseNameHeight = (courseNameLines.length * fontHeight) + ((courseNameLines.length - 1) * lineSpacing) + 10;
                        const calculatedCourseCodeLinesHeight = (courseCodeLines.length * fontHeight) + ((courseCodeLines.length - 1) * lineSpacing) + 10;

                        // 3. Find the maximum height for the entire row
                        finalRowHeight = Math.max(cellHeight, calculatedNameHeight, calculatedCourseNameHeight, calculatedCourseCodeLinesHeight);

                        // ==========================================
                        // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                        // ==========================================
                        if (pdf_position_y + finalRowHeight > maxPrintableY) {
                            pdf.addPage();
                            pdf_position_y = margin_t; // Reset to the top of the new page

                            // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                            headerX = margin_l;
                            renderTableHeader();
                        }
                        // ==========================================

                        // --- DRAW COLUMN 1: Student ID ---
                        pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                        this.thaitext(pdf, txtId, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[0];

                        // --- DRAW COLUMN 2: Student Name ---
                        pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                        const totalNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing);
                        let nameY = pdf_position_y + (finalRowHeight - totalNameHeight) / 2 + fontHeight;
                        nameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, nameY);
                            nameY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[1];

                        // --- DRAW COLUMN 3: Course Code ---
                        pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                        const totalCourseCodeHeight = (courseCodeLines.length * fontHeight) + ((courseCodeLines.length - 1) * lineSpacing);
                        let courseCodeY = pdf_position_y + (finalRowHeight - totalCourseCodeHeight) / 2 + fontHeight;
                        courseCodeLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, courseCodeY);
                            courseCodeY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[2];

                        // --- DRAW COLUMN 4: Course Name (Wrapped) ---
                        pdf.rect(columnX, pdf_position_y, colWidths[3], finalRowHeight);
                        const totalCourseNameHeight = (courseNameLines.length * fontHeight) + ((courseNameLines.length - 1) * lineSpacing);
                        let courseNameY = pdf_position_y + (finalRowHeight - totalCourseNameHeight) / 2 + fontHeight;
                        courseNameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, courseNameY);
                            courseNameY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[3];

                        // --- DRAW COLUMN 5: Enroll date ---
                        pdf.rect(columnX, pdf_position_y, colWidths[4], finalRowHeight);
                        this.thaitext(pdf, enrolledAt, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[4];

                        // --- DRAW COLUMN 6: Learning Time ---
                        pdf.rect(columnX, pdf_position_y, colWidths[5], finalRowHeight);
                        this.thaitext(pdf, learningTime, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[5];

                        // 4. Move Y down cleanly by the shared unified row height
                        pdf_position_y += finalRowHeight;
                    });

                    pdf.addPage();
                    pdf_position_y = margin_t;

                    pdf.setFont("Sarabun", "bold");
                    this.thaitext(
                        pdf,
                        "สรุปจำนวนผู้ทดลองเรียนรายคอร์ส",
                        margin_l,
                        pdf_position_y
                    );
                    addNewPageIfNeeded(this.pdfConfig.endNormal);

                    const tableSummaryHeader = ["ลำดับ", "รหัสคอร์ส", "ชื่อคอร์ส", "จำนวนผู้เรียน\n(คน)"];
                    const SummaryColWidths = [40, 60, 200, 65];
                    pdf.setLineWidth(0.1);
                    pdf.setFont("Sarabun", "bold");
                    headerX = margin_l;
                    cellHeight = 35;

                    for (let i = 0; i < tableSummaryHeader.length; i++) {
                        const width = SummaryColWidths[i];

                        // 1. Draw Header Cell Border
                        pdf.rect(headerX, pdf_position_y, width, cellHeight);

                        // 2. Split text by newline for multiline support
                        const lines = tableSummaryHeader[i].split('\n');
                        const totalLines = lines.length;

                        // Calculate the starting Y position so the entire block of text is vertically centered
                        const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                        let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                        // 3. Loop through and center each individual line
                        for (let j = 0; j < totalLines; j++) {
                            const lineText = lines[j];

                            // Calculate horizontal center for the current line
                            const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                            const textX = headerX + (width - textWidth) / 2;

                            // Render the text using your custom Thai text function
                            this.thaitext(pdf, lineText, textX, startY);

                            // Move Y down for the next line
                            startY += fontHeight + lineSpacing;
                        }

                        headerX += width;
                    }
                    pdf_position_y += cellHeight;
                    pdf.setFont("Sarabun", "normal");
                    cellHeight = 20

                    this.courseSummary.forEach((row, index) => {
                        let columnX = margin_l;
                        const studentCount = row.studentCount ? row.studentCount.toString() : '0';
                        const courseCode = row.courseCode ? row.courseCode : "-"

                        // 1. Split long text into arrays of wrapped lines
                        const padding = 10;
                        const nameLines = pdf.splitTextToSize(row.courseName, SummaryColWidths[2] - padding);
                        const courseCodeLines = pdf.splitTextToSize(courseCode, SummaryColWidths[1] - padding);

                        // 2. Calculate heights for individual text blocks
                        const fontHeight = pdf.getFontSize() * 0.3528;
                        const lineSpacing = 5;
                        const calculatedNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing) + 10;
                        const calculatedCourseCodeLinesHeight = (courseCodeLines.length * fontHeight) + ((courseCodeLines.length - 1) * lineSpacing) + 10;

                        // 3. Find the maximum height for the entire row
                        const finalRowHeight = Math.max(cellHeight, calculatedNameHeight, calculatedCourseCodeLinesHeight);

                        // ==========================================
                        // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                        // ==========================================
                        if (pdf_position_y + finalRowHeight > maxPrintableY) {
                            pdf.addPage();
                            pdf_position_y = margin_t; // Reset to the top of the new page

                            // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                            let headerX = margin_l;
                            pdf.setLineWidth(0.1);

                            for (let i = 0; i < tableSummaryHeader.length; i++) {
                                const width = SummaryColWidths[i];
                                pdf.rect(headerX, pdf_position_y, width, cellHeight); // assumes global cellHeight for headers

                                const lines = tableSummaryHeader[i].split('\n');
                                const totalLines = lines.length;
                                const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * 2);
                                let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                                for (let j = 0; j < totalLines; j++) {
                                    const textWidth = pdf.getStringUnitWidth(lines[j]) * pdf.getFontSize() / pdf.internal.scaleFactor;
                                    this.thaitext(pdf, lines[j], headerX + (width - textWidth) / 2, startY);
                                    startY += fontHeight + 2;
                                }
                                headerX += width;
                            }
                            // Move Y position down past the header block
                            pdf_position_y += cellHeight;
                        }
                        // ==========================================

                        // --- DRAW COLUMN 1: No. ---
                        pdf.rect(columnX, pdf_position_y, SummaryColWidths[0], finalRowHeight);
                        const idxText = (index + 1).toString();
                        const idxWidth = pdf.getStringUnitWidth(idxText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                        this.thaitext(pdf, idxText, columnX + (SummaryColWidths[0] - idxWidth) / 2, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += SummaryColWidths[0];

                        // --- DRAW COLUMN 2: Course Code ---
                        pdf.rect(columnX, pdf_position_y, SummaryColWidths[1], finalRowHeight);
                        const totalCourseCodeHeight = (courseCodeLines.length * fontHeight) + ((courseCodeLines.length - 1) * lineSpacing);
                        let courseCodeY = pdf_position_y + (finalRowHeight - totalCourseCodeHeight) / 2 + fontHeight;
                        courseCodeLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, courseCodeY);
                            courseCodeY += fontHeight + lineSpacing;
                        });
                        columnX += SummaryColWidths[1];

                        // --- DRAW COLUMN 3: Course Name (Wrapped) ---
                        pdf.rect(columnX, pdf_position_y, SummaryColWidths[2], finalRowHeight);
                        const totalNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing);
                        let nameY = pdf_position_y + (finalRowHeight - totalNameHeight) / 2 + fontHeight;
                        nameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, nameY);
                            nameY += fontHeight + lineSpacing;
                        });
                        columnX += SummaryColWidths[2];

                        // --- DRAW COLUMN 4: Student Count ---
                        const studentCountText = (studentCount).toString();
                        const studentCountWidth = pdf.getStringUnitWidth(studentCountText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                        pdf.rect(columnX, pdf_position_y, SummaryColWidths[3], finalRowHeight);
                        this.thaitext(pdf, studentCount, columnX + (SummaryColWidths[3] - studentCountWidth) / 2, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += SummaryColWidths[3];

                        pdf_position_y += finalRowHeight;
                    });

                    // ==========================================
                    // DRAW THE TOTAL SUMMARY ROW
                    // ==========================================

                    // 1. Calculate total sum dynamically from your list
                    const totalStudents = this.courseSummary.reduce((sum, row) => sum + (Number(row.studentCount) || 0), 0);

                    // 2. Check if there is enough space on the current page for the summary row
                    if (pdf_position_y + finalRowHeight > maxPrintableY) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset to top if it overflows
                    }

                    // 3. Set the font style to Bold for the summary row
                    pdf.setFont("Sarabun", "bold");

                    let currentX = margin_l;

                    // Combine widths of Column 1, 2, and 3 for the text "รวมทั้งหมด"
                    const spanWidth = SummaryColWidths[0] + SummaryColWidths[1] + SummaryColWidths[2];

                    // Draw the rectangle background for the spanned section (optional grey background like the image)
                    pdf.setFillColor(240, 240, 240); // Light grey color
                    pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, 'F'); // Fill background
                    pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, 'S'); // Draw border stroke

                    // Calculate text width for right alignment with a small padding (e.g., 15 units from the right edge)
                    const labelText = "รวมทั้งหมด";
                    const labelWidth = pdf.getStringUnitWidth(labelText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    const labelX = currentX + spanWidth - labelWidth - 15;
                    const labelY = pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight;

                    // Render "รวมทั้งหมด"
                    this.thaitext(pdf, labelText, labelX, labelY);

                    // Move currentX to the 4th column (Course Count)
                    currentX += spanWidth;

                    // 4. Draw Column 4: Total sum number box
                    pdf.setFillColor(240, 240, 240);
                    pdf.rect(currentX, pdf_position_y, SummaryColWidths[3], finalRowHeight, 'F');
                    pdf.rect(currentX, pdf_position_y, SummaryColWidths[3], finalRowHeight, 'S');

                    const totalText = totalStudents.toString();
                    const totalWidth = pdf.getStringUnitWidth(totalText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    // Center align the total number in the last column
                    const totalX = currentX + (SummaryColWidths[3] - totalWidth) / 2;

                    this.thaitext(pdf, totalText, totalX, labelY);

                    pdf_position_y += finalRowHeight;
                }

                setTimeout(() => {
                    pdf.save("รายงานการทดลองเรียน.pdf");
                }, 0);
                this.isDisableDownloadReportBtn = false;
            } catch (error) {
                console.log(error)
            }
        }
    }
}